module.exports = __webpack_public_path__ + "static/media/3.4e33efa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mozyr/3.jpg
// module id = 240
// module chunks = 0